var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrRightPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.48839 0.223469C7.18686 -0.0745416 6.69797 -0.0744395 6.39655 0.223469C6.09492 0.521683 6.09492 1.00493 6.39665 1.30315L9.36355 4.23633L0.771993 4.23714C0.345591 4.23725 4.79748e-07 4.57892 5.16621e-07 5.00069C0.00010355 5.42226 0.345693 5.76384 0.772095 5.76384L9.36397 5.76302L6.39634 8.69682C6.09481 8.99493 6.09481 9.47838 6.39634 9.77639C6.54716 9.9254 6.74471 10 6.94237 10C7.13992 10 7.33747 9.9254 7.48829 9.77649L11.7738 5.53962C11.9187 5.39651 12 5.20242 12 4.99988C11.9999 4.79734 11.9186 4.60335 11.7737 4.45994L7.48839 0.223469Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRightPopup);
export default __webpack_public_path__ + "static/media/arr-right-popup.bd96880de9f49ff679dd61ea5f56367f.svg";
export { ForwardRef as ReactComponent };